export default "__VITE_ASSET__BX47ighW__"